import capitalize from 'lodash/capitalize';

import { COUNTRIES } from '@cdaas/reusable-components-daas';
import { i18n } from '../i18n';

// This function is made for mapping backend and frontend country values
// Will be used after data models are approved
export const mapCountryValue = (value: string, to: 'shortCode' | 'fullName'): string => {
  const foundCountry = COUNTRIES.find(country => (to === 'shortCode' ? country.countryName === value : country.value === value));

  if (to === 'shortCode') {
    return foundCountry?.value ?? '';
  }

  const countryName = foundCountry?.countryName;
  if (!countryName) {
    return '';
  }

  return i18n.t(`globalComponents:countries.${capitalize(countryName)}`);
};
